<div class="pending-plans-wrapper" [@fadeIn]>

  <!-- Header -->
  <div class="section-header">
    <div class="section-header-left">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256" fill="currentColor" class="section-icon">
        <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm40-68a28,28,0,0,1-28,28H128v8a8,8,0,0,1-16,0v-8H96a8,8,0,0,1,0-16h28v-28H112a44,44,0,0,1,0-88h4V36a8,8,0,0,1,16,0v8h16a8,8,0,0,1,0,16H112a28,28,0,0,0,0,56h12V88h12a28,28,0,0,1,32,28Z" opacity="0.3"/>
        <path d="M168,148a28,28,0,0,1-28,28H128v8a8,8,0,0,1-16,0v-8H96a8,8,0,0,1,0-16h44a12,12,0,0,0,0-24H116a44,44,0,0,1,0-88h4V36a8,8,0,0,1,16,0v8h16a8,8,0,0,1,0,16H116a28,28,0,0,0,0,56h12a44,44,0,0,1,40,44Z"/>
      </svg>
      <div>
        <h2 class="title-secondary">Planos Aguardando Aceitação</h2>
        <p class="title-secondary-description">Analise e aceite ou rejeite a responsabilidade de pagamento</p>
      </div>
    </div>
    <button mat-icon-button (click)="loadPendingPlans()" [disabled]="isLoading()" matTooltip="Atualizar">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <!-- Loading -->
  <mat-progress-bar *ngIf="isLoading()" mode="indeterminate" color="primary"></mat-progress-bar>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="!isLoading() && plans().length === 0">
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 256 256" fill="currentColor" class="empty-icon">
      <path d="M229.66,218.34l-50.06-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.31-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z" opacity="0.3"/>
      <path d="M229.66,218.34l-50.06-50.06a88.21,88.21,0,1,0-11.32,11.31l50.06,50.07a8,8,0,1,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z"/>
    </svg>
    <p class="empty-title">Nenhum plano pendente</p>
    <p class="empty-desc">Não há planos aguardando sua aceitação no momento.</p>
  </div>

  <!-- Cards List -->
  <div class="plans-grid" [@listStagger]="plans().length" *ngIf="!isLoading() && plans().length > 0">
    <div class="card plan-pending-card" *ngFor="let plan of plans()" [@fadeIn]>

      <!-- Card Header -->
      <div class="card-header plan-pending-header">
        <div class="plan-pending-title-row">
          <span class="badge badge-warning">
            <mat-icon class="badge-icon">hourglass_top</mat-icon>
            Aguardando decisão
          </span>
          <span class="plan-id-tag">#{{ plan.id }}</span>
        </div>
        <h3 class="card-title">{{ plan.name || 'Plano sem nome' }}</h3>
      </div>

      <!-- Card Body -->
      <div class="card-body plan-pending-body">
        <div class="info-row">
          <span class="info-label">Titular (CPF/CNPJ)</span>
          <span class="info-separator"></span>
          <span class="info-data">{{ formatCnpj(plan.cpfcnpj) }}</span>
        </div>
        <div class="info-row" *ngIf="plan.packageType">
          <span class="info-label">Pacote</span>
          <span class="info-separator"></span>
          <span class="info-data">{{ plan.packageType }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Valor Total</span>
          <span class="info-separator"></span>
          <span class="info-data value-highlight">{{ formatCurrency(plan.finalTotal) }}</span>
        </div>
      </div>

      <!-- Card Footer -->
      <div class="card-footer plan-pending-actions">
        <button
          mat-stroked-button
          color="warn"
          class="btn-action"
          (click)="onReject(plan)"
          [disabled]="isProcessing(plan.id)">
          <mat-spinner *ngIf="isProcessing(plan.id)" diameter="18" class="btn-spinner"></mat-spinner>
          <mat-icon *ngIf="!isProcessing(plan.id)">close</mat-icon>
          Rejeitar
        </button>
        <button
          mat-flat-button
          color="primary"
          class="btn-action"
          (click)="onAccept(plan)"
          [disabled]="isProcessing(plan.id)">
          <mat-spinner *ngIf="isProcessing(plan.id)" diameter="18" class="btn-spinner"></mat-spinner>
          <mat-icon *ngIf="!isProcessing(plan.id)">check</mat-icon>
          Aceitar
        </button>
      </div>

    </div>
  </div>

</div>
